<div class="accept-cert-modal" [ngClass]="{ 'modal-compact': !isFullMode }">
    <div *ngIf="isFullMode" class="modal-header">
        <div class="header-container">
            <cm-certificate-icon
                [ngClass]="{ 'empty-state': !cert.certification_logo }"
                class="organization-logo"
                [certificate]="cert"
            >
            </cm-certificate-icon>
            <h3 class="prof-header prof-header--level-3">{{ heading }}</h3>
        </div>
    </div>
    <div class="modal-body">
        <div [ngSwitch]="state">
            <div *ngSwitchCase="STATES.UPLOAD">
                <div [formGroup]="dateForm" *ngIf="isFullMode">
                    <p class="details-description font-weight-bold" style="margin-bottom: 6px">
                        Date when the credential was completed
                    </p>
                    <cm-datepicker class="ch-datepicker" [useDeprecatedDateOutputFormat]="true" formControlName="date">
                    </cm-datepicker>
                    <p class="details-description font-weight-bold">Upload credential file(s)</p>
                    <cm-file-upload (change)="onFilesChange($event)" [files]="files"></cm-file-upload>
                </div>
                <cm-inline-error *ngIf="error" [errorMessages]="errorMessages"></cm-inline-error>
            </div>
            <div *ngSwitchCase="STATES.INITIAL">
                <p>
                    If you would like to complete the process for a new credential or renewal of an expired credential,
                    please click <span class="bold">PROCEED IN CERTEMY</span> to continue.
                </p>
                <p>
                    If you have previously completed all steps required to receive your credential outside of the
                    Certemy platform and wish to upload proof for completion, please select
                    <span class="bold">UPLOAD EXISTING</span>. (THIS FEATURE SHOULD ONLY BE USED TO PROVIDE A COMPLETE
                    SET OF EVIDENCE, OTHERWISE YOU MUST SELECT PROCEED IN CERTEMY TO COMPLETE ALL REQUIRED STEPS)
                </p>
            </div>
        </div>
    </div>
    <cm-confirm-info *ngIf="!isFullMode" [info]="uploadInfo"></cm-confirm-info>
    <div class="modal-footer">
        <ng-container [ngSwitch]="state">
            <ng-container *ngSwitchCase="STATES.UPLOAD">
                <ng-container *ngIf="isFullMode">
                    <button class="btn btn-default" (click)="goToState(STATES.INITIAL)">back</button>
                    <button class="btn btn-primary" type="button" (click)="submit()">
                        Submit document for verification
                    </button>
                </ng-container>
                <ng-container *ngIf="!isFullMode">
                    <button class="btn btn-default" type="button" (click)="back()">Back</button>
                    <button class="btn btn-primary" type="button" (click)="sendCertificateForVerification()">
                        Confirm
                    </button>
                </ng-container>
            </ng-container>
            <ng-container *ngSwitchCase="STATES.INITIAL">
                <button class="btn btn-default" (click)="close()">Close</button>
                <button class="btn btn-default" type="button" (click)="goToState(STATES.UPLOAD)">
                    Upload existing
                </button>
                <button class="btn btn-primary" type="button" (click)="sendAccept()">Proceed in certemy</button>
            </ng-container>
        </ng-container>
    </div>
</div>
